import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { PrototypeVariantLayout } from "./PrototypeVariantLayout";

const BrandPortalIssuesPagePage = lazy(() => import("./Page"));
const PinewoodGoodsOrderPage = lazy(() => import("./PinewoodGoodsOrderPage"));
const IssueReportPage = lazy(() => import("./IssueReportPage"));
const SettingsPage = lazy(() => import("./SettingsPage"));
const CustomerServiceAnalyticsPage = lazy(
  () => import("./CustomerServiceAnalyticsPage")
);

export const BrandPortalIssuesPrototypeRoutes = () => (
  <PrototypeVariantLayout>
    <Switch>
      <Route
        path="/ck/brand-portal-issues-page/orders/:orderId/report"
        component={IssueReportPage}
      />
      <Route
        path="/ck/brand-portal-issues-page/orders/:orderId"
        component={PinewoodGoodsOrderPage}
      />
      <Route
        path="/ck/brand-portal-issues-page/settings"
        component={SettingsPage}
      />
      <Route
        path="/ck/brand-portal-issues-page/analytics/customer-service"
        component={CustomerServiceAnalyticsPage}
      />
      <Route
        exact
        path="/ck/brand-portal-issues-page"
        component={BrandPortalIssuesPagePage}
      />
    </Switch>
  </PrototypeVariantLayout>
);
